import {Dialog, DialogTitle, DialogContent, DialogActions, Box, Button, FormControl, IconButton, InputLabel, List, MenuItem, Select, SelectChangeEvent, Stack, TextField, Tooltip, Typography, FormControlLabel, Checkbox } from "@mui/material"
import Table from "../custom/Table"
import Modal from "../Modals"
import { INV_ACTION_MODAL, INV_LINEITEM_MODAL, INV_SERIALNUMBER_MODAL, INV_STO_TABLE, MyObject, RowStatus, TranscationData, transcationFields, IStoUpdate } from "../../Models/Inventory"
import { useCallback, useContext, useEffect, useState } from "react"
import { GridColDef, GridFilterModel, GridRowModel, GridRowSelectionModel, GridToolbar } from "@mui/x-data-grid"
import VisibilityIcon from '@mui/icons-material/Visibility';
import styled from "styled-components"
import CreateStockModal from './CreateStockModal';
import Title from "../custom/Title"
import { AuthContext } from "../../contexts/AuthContext"
import { InventoryContext } from "../../contexts/InventoryContext"
import useService from "../../hooks/useService"
import { getStos, getStosLineItem, cancelSTOTransfer, updateAWBNumber, acknowledgeStockTransferOrder, getStoDeliveryChallan, generateIRN, stockOutDetail } from "../../services/Inventory"
import {  getLotDetails } from '../../services/Transactions'
import { NotificationContext } from "../../contexts/NotificationContext";
import { ShowSerialNumbers, ShowTranscationDetails, getInventoryType } from "./InventoryShowcase"
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import moment from "moment"
import {getFormattedCurrency} from '../../utils/helpers'
import { DOCUMENT_TYPES } from "../../utils/constant"
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import DateTimePicker from "../Modals/DateTimePicker"

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`
const MetalImage = styled.img`
  object-fit: contain;
  max-width: 100px;
  max-height: 45px;
  border-radius: 4px;
  padding: 3px 0;
`
let InventoryStatus: any = {
  '0': 'Not dispatched',
  '1': 'Pending/In Transit',
  '2': 'Acknowledged completely',
  '3': 'Partially acknowledged',
  // '4': 'Lost in transit',
  // '5': 'Partially lost in transit',
  '6': 'Cancelled',
}

const InventoryType: any = {
  1: 'Normal SKU',
  2: 'Cut Bar/Loose Items',
  3: 'Buffing dust',
  4: 'Scrap from barter/buyback',
  5: 'Jobwork metal',
  6: 'GMS metal',
  7: 'Non-Serialized SKU'
}

type TStoData = {
  stoId: string
  createdAt: string
}

type MetalType = 'gold' | 'silver';
type MetalCode = 'MTG' | 'MTS';

interface ResultItem {
  metalType: MetalType;
  [key: string]: any;
}

interface InvoiceDetails {
  document_number: string;
  created_at: string;
}

interface MTSDataTransferType {
  invoiceDetails: InvoiceDetails;
  mts_location_code: string;
  TotalNetWeight: number;
  TotalFineWeight: number;
  shipperId: string;
  remarks?: string;
}

interface PayloadData {
  InvoiceNo: string;
  InvoiceDate: string;
  PVCCode: string;
  MetalType: MetalCode;
  TotalNetWeight: number;
  TotalFineWeight: number;
  Name: string;
  Remarks?: string;
  LineItemXML: string;
  pvcMetalInboundItemModel: ResultItem[];
}

interface MetalPayload {
  MTGData?: PayloadData;
  MTSData?: PayloadData;
}

const outboundStatus = [
  {
    value: 2,
    label: 'Acknowledged completely'
  },
  {
    value: 3,
    label: 'Partially acknowledged'
  },
  // {
  //   value: 4,
  //   label: 'Lost in transit'
  // },
  // {
  //   value: 5,
  //   label: 'Partially lost in transit'
  // }
]

const inboundsStatus = [
  {
    value: 2,
    label: 'Acknowledged completely'
  },
  {
    value: 6,
    label: 'Cancelled'
  }
]

export const InventoryRequest = () => {
  return (
    <div>
        <StoDetails/>
    </div>
  )
}

function StoDetails() {
  const { execute } = useService()
  const { user } = useContext(AuthContext)
  const { notify } = useContext(NotificationContext);
  const { inventoriesStoRows,inventories } = useContext(InventoryContext) // STO's recieved state
  const [showLineItemDetail, setShowLineItemDetail] = useState<boolean>(false) // Line Items Modal
  const [lineItemDetails, setLineItemDetails] = useState(""); // stoId state,
  const [showSTOModal, setShowSTOModal] = useState<boolean | string>(false) // Create Stock Transfer Modal
  const [linedItemModalHeading, setLinedItemModalHeading] = useState<string>('');
  const [showActionModal, setShowActionModal] = useState(false); // Action Modal State
  const [STOEditModalData, setSTOEditModalData] = useState<boolean | string>(false)
  const [stoTransferType, setStoTransferType] = useState('')
  const [editModalData, setEditModalData] = useState<boolean | TStoData | TStoData[]>(false)
  
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 }) // Pagination State
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: []
  })
  const [selectedStoIds, setSelectedStoIds] = useState<TStoData[]>([]);

  const closeEditModal = () => {
    setEditModalData(false)
  }

  const closeSTOEditModal = () => {
    setSTOEditModalData(false)
  }
  
  const closeSTOModal = () => {
    setShowSTOModal(false)
  }

  const closeAcknowledgeModal = () => {
    setShowLineItemDetail(false)
    setShowActionModal(false)
  }

  const HandleLineItemModal = (params:any, heading:string) => {
    setLinedItemModalHeading(heading);
    setShowLineItemDetail(params.requestedSkuDetail);
    setLineItemDetails(params.stoId);
  }

  const HandleActionModal = (params:any, heading:string) => {
    setLinedItemModalHeading(heading);
    setLineItemDetails(params.stoId);
    setShowActionModal(params.requestedSkuDetail);
    setStoTransferType(params.MTSTransferType)
   }

  const getStoChallanInvoice = async (stoId: string, docType?:string) => {
    console.log('docType',docType)
    if(docType === DOCUMENT_TYPES.ANNEXURE){
      const { data, error } = await execute(() => getStoDeliveryChallan({ stoId, type: DOCUMENT_TYPES.ANNEXURE }))
     
      if(data)  window.open(data?.url, '_blank')
    }
    else if(docType === DOCUMENT_TYPES.SERVICE_TAX_INVOICE){
      const { data, error } = await execute(() => getStoDeliveryChallan({ stoId, type: DOCUMENT_TYPES.SERVICE_TAX_INVOICE }))
      console.log('invoice',data)
      if(data)  window.open(data?.url, '_blank')
    }
    else{
      const { data, error } = await execute(() => getStoDeliveryChallan({ stoId , type: docType})) // handling in backend
      if(data)  window.open(data?.url, '_blank')
      }

  }

  const handleBulkStoIdChange = (e: { target: { checked: boolean } }, row: GridRowModel) => {
    setSelectedStoIds((prev) => {
      if(e.target.checked) { 
        return [...prev, { stoId: row.stoId, createdAt: row.createdAt } as TStoData]
      } else {
        return prev.filter((item) => item.stoId !== row.stoId)
      }
    })
  }

  const getInventoryColumns = () => {
    let minWidth = 100

    return INV_STO_TABLE.map(inboundField => {

        const row: GridColDef = {
            field: inboundField.id,
            headerName: inboundField.label,
            minWidth,
            headerAlign: 'left',
            align: 'left'
        }

        switch (inboundField.id) {
            case "stoId":
                row.minWidth = 120;
                row.type = 'string';
                row.renderCell = params => {
                  return params.row.stoId ? params.row.stoId : "NA"
                }
                break;
            case "awbNumber":
                row.minWidth = 180;
                row.type = 'string';
                row.renderCell = params => {
                return params.row.awbNumber ? params.row.awbNumber : "NA"
                }
                break;
            case "downloadInvoice":
                row.minWidth = 180;
                row.filterable = false;
                row.renderCell = params => {
                let lineItems = params.row.lineItems
                let notAnnexture = lineItems.every((row: any) => row.global_transaction_number === null)
                let IsServiceInvoice = params.row?.is_service_tax_invoice
                return (
                  <>
                    <Tooltip title={'Download DC / Invoice'}>
                      <IconButton style={{ marginLeft: '-10px' }} onClick={() => getStoChallanInvoice(params.row.stoId, params.row.deliveryChallanNo.includes("TI") ? DOCUMENT_TYPES.TAX_INVOICE: DOCUMENT_TYPES.DELIVERY_CHALLAN)}> 
                        <DownloadIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={'Download Annexure'}>
                      <IconButton disabled={notAnnexture} style={{ marginLeft: '10px' }} onClick={() => getStoChallanInvoice(params.row.stoId, DOCUMENT_TYPES.ANNEXURE)}>
                        <DownloadIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={'Download Service Tax Invoice'}>
                      <IconButton disabled={!IsServiceInvoice} style={{ marginLeft: '10px' }} onClick={() => getStoChallanInvoice(params.row.stoId, DOCUMENT_TYPES.SERVICE_TAX_INVOICE)}>
                        <DownloadIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                  </>
                )
                }
              break;
            case "createdAt":
                row.minWidth = 200;
                row.type = 'dateTime';
                row.valueGetter = params => {
                  return params.row.createdAt && new Date(params.row.createdAt)
                }
                break;
            case "updatedAt":
                row.minWidth = 200;
                row.type = 'dateTime';
                row.valueGetter = params => {
                  return params.row.updatedAt && new Date(params.row.updatedAt)
                }
                break;
            case "status":
                row.minWidth = 180;
                row.type = 'string';
                row.renderCell = params => {
                  return InventoryStatus[params.row.status]
                }
                break;
            case "shipperId":
                row.minWidth = 200;
                row.type = 'string';
                row.renderCell = params => {
                  let isValidShipperId = params.row.isMTSTransfer === true && params.row.MTSTransferType === "inbound"
                    return (
                      <Tooltip title={params.row.shipperId}>
                        <Typography>{params.row.shipperId}</Typography>
                      </Tooltip>
                    )
                }
                break;
            case "destinationId":
              row.minWidth = 200;
              row.type = 'string';
              row.renderCell = params => {
                  let isDestinationId = params.row.isMTSTransfer === true && params.row.MTSTransferType === "outbound"
                  return(
                    <Tooltip title={params.row.destinationId}>
                      <Typography>{params.row.destinationId}</Typography>
                    </Tooltip>
                  ) 
              }
              break;
            case "deliveryChallanNo":
              row.minWidth = 200;
              row.type = 'string';
              row.renderCell = params => {
                  let deliveryChallanNo = params.row.deliveryChallanNo ? params.row.deliveryChallanNo : "NA"
                  return(
                    <Tooltip title={deliveryChallanNo}>
                      <Typography>{deliveryChallanNo}</Typography>
                    </Tooltip>
                  )
              }
              break;
            case "totalGoldWeight":
              row.minWidth = 150;
              row.type = 'number';
              row.renderCell = params => {
                  return params.row.totalGoldWeight ? params.row.totalGoldWeight.toFixed(3) : "NA"
              }
              break;
            case "totalGoldFineWeight":
              row.minWidth = 150;
              row.type = 'number';
              row.renderCell = params => {
                  return params.row.totalGoldFineWeight ? params.row.totalGoldFineWeight.toFixed(3) : "NA"
              }
              break;
            case "totalSilverWeight":
              row.minWidth = 150;
              row.type = 'number';
              row.renderCell = params => {
                  return params.row.totalSilverWeight ? params.row.totalSilverWeight.toFixed(3) : "NA"
              }
              break;
            case "totalSilverFineWeight":
              row.minWidth = 150;
              row.type = 'number';
              row.renderCell = params => {
                  return params.row.totalSilverFineWeight ? params.row.totalSilverFineWeight.toFixed(3) : "NA"
              }
              break;
            case "isMTSTransfer":
              row.minWidth = 150;
              row.type = 'boolean';
              row.renderCell = params => {
                  return params.row.isMTSTransfer === true ? "Yes" : "No"
              }
              break;
            case "MTSTransferType":
              row.minWidth = 150;
              row.type = 'string';
              row.renderCell = params => {
                  return params.row.MTSTransferType ? params.row.MTSTransferType : "NA"
              }
              break;
            case "isMTSUpdated":
              row.minWidth = 150;
              row.type = 'boolean';
              row.renderCell = params => {
                return params.row.isMTSUpdated ? params.row.isMTSUpdated : "NA"
              }
              break;
            case "fullName":
              row.minWidth = 200;
              row.type = 'string';
              row.renderCell = params => {
                return (
                  <Tooltip title={params.row.fullName ? params.row.fullName : "NA"}>
                    <Typography>{params.row.fullName ? params.row.fullName : "NA"}</Typography>
                  </Tooltip>
                )
              }
              break;
            case "remarks":
              row.minWidth = 220;
              row.type = 'string';
              row.renderCell = params => {
                return (
                  <Tooltip title={params.row.remarks ? params.row.remarks : "NA"}>
                    <Typography>{params.row.remarks ? params.row.remarks : "NA"}</Typography>
                  </Tooltip>
                )
              }
              break;
            case "acknowledgementRemarks":
              row.minWidth = 220;
              row.type = 'string';
              row.renderCell = params => {  
                return (
                  <Tooltip title={params.row.acknowledgementRemarks ? params.row.acknowledgementRemarks : "NA"}>
                    <Typography>{params.row.acknowledgementRemarks ? params.row.acknowledgementRemarks : "NA"}</Typography>
                  </Tooltip>
                )
              }
              break;
            case "acknowledgedAt":
              row.minWidth = 200;
              row.type = 'dateTime';
              row.valueGetter = params => {
                return params.row.acknowledgedAt && new Date(params.row.acknowledgedAt)
              }
              break;
            case "MTSDeliveryChallanCode":
              row.minWidth = 250;
              row.type = 'string';
              row.renderCell = params => {
                return(
                  <Tooltip title={`${params.row.MTSDeliveryChallanCode ? params.row.MTSDeliveryChallanCode : "NA"}`}>
                    <Typography>{params.row.MTSDeliveryChallanCode ? params.row.MTSDeliveryChallanCode : "NA"}</Typography>
                  </Tooltip>
                ) 
              }
              break;
            case "grossRate":
              row.minWidth = 150;
              row.type = 'number';
              row.renderCell = params => {
                return params.row.grossRate ? getFormattedCurrency(params.row.grossRate,true) : "NA"
              }
              break;
            case "invoiceGrandTotal":
              row.minWidth = 150;
              row.type = 'number';
              row.renderCell = params => {
                return params.row.invoiceGrandTotal ? getFormattedCurrency(params.row.invoiceGrandTotal,true) : "NA"
              }
              break;
            case "lineItem":
              row.minWidth = 150;
              row.filterable = false;
              row.align = 'center'
              row.renderCell = params => {
                let iconToBeShown = params.row?.shipperId
                // && parseInt(params.row.status) === 1
                return <>
                  { iconToBeShown ?
                    <Tooltip title='View line item details'>
                      <IconButton style={{ marginLeft: '-10px' }} onClick={() => HandleLineItemModal(params.row, params.row.stoId)}><VisibilityIcon /></IconButton>
                    </Tooltip> : "NA"
                  }
                </>
              }
              break;
            case "acknowledge":
                row.minWidth = 150;
                row.filterable = false;
                row.renderCell = params => {
                  return <>{
                    params.row.destinationId === user.centerId && parseInt(params.row.status) === 1
                    ? <Tooltip title={'Acknowledge line items'}>
                        <IconButton style={{ marginLeft: '-10px' }} onClick={()=>HandleActionModal(params.row, params.row.stoId)}>
                          <CheckCircleIcon />
                        </IconButton>
                    </Tooltip>
                    : "NA"
                  }</>
                }
                break;
            case "actions":
              row.minWidth = 180;
              row.filterable = false;
              row.renderCell = params => {
                const status = parseInt(params.row.status)
                const canUpdate = params.row.shipperId === user.centerId && status === 0
                const canCancel = params.row.shipperId === user.centerId && [0, 1].includes(status)

                const canGenerateIRN =
                  params.row.shipperId === user.centerId &&
                  status === 0 &&
                  params.row.invoiceDetails?.type === DOCUMENT_TYPES.TAX_INVOICE &&
                  (params.row.invoiceDetails?.raw_data?.IRNNumber ?? "").trim() === ""

                const showAnyAction = canUpdate || canCancel || canGenerateIRN

                return(
                <>
                  {showAnyAction ? (
                    <>
                      {canUpdate && (
                        <Tooltip title="Update STO transfer">
                          <IconButton
                            style={{ marginLeft: '-10px' }}
                            onClick={() => setSTOEditModalData(params.row)}
                          >
                            <CheckCircleIcon />
                          </IconButton>
                        </Tooltip>
                      )}

                      {canCancel && (
                        <Tooltip title="Cancel STO transfer">
                          <IconButton
                            style={{ marginLeft: '-10px' }}
                            onClick={() => handleCalcelSTOTransfer(params.row.stoId)}
                          >
                            <CancelIcon />
                          </IconButton>
                        </Tooltip>
                      )}

                      {canGenerateIRN && (
                        <Tooltip title="Generate IRN">
                          <IconButton
                            style={{ marginLeft: '-10px' }}
                            onClick={() => handleGenerateIRN(params.row.stoId)}
                          >
                            <ReceiptLongIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </>
                  ) : (
                    'NA'
                  )}
                  {user?.isPlantPvc! && params.row.shipperId ===  user?.centerId && !params.row.metalOutTime
                  ? <>
                      <Tooltip title={'Edit Plant STO'}>
                        <IconButton style={{ marginLeft: '80px' }} onClick={() => setEditModalData({ stoId: params.row.stoId, createdAt: params.row.createdAt })} disabled={selectedStoIds.length > 0}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                        <FormControlLabel
                          sx={{ color: "#7f7d76" }}
                          control={
                            <Checkbox
                              size='small'
                              onChange={(e)=>handleBulkStoIdChange(e, params.row)}
                              checked={selectedStoIds.findIndex(item => item.stoId === params.row.stoId) > -1}
                            />
                          }
                          label=''
                        />
                    </>
                  : ''}
                </>)
              }
              break;
            case "linkedTransactionType":
              row.minWidth = 180;
              row.type = 'string';
              row.renderCell = params => {
                return (
                  <Tooltip title={params.row.linkedTransactionType ? params.row.linkedTransactionType : "NA"}>
                    <Typography>{params.row.linkedTransactionType ? params.row.linkedTransactionType : "NA"}</Typography>
                  </Tooltip>
                )
              }
              break;  
            case "metalOutTime":
                row.minWidth = 200;
                row.type = 'dateTime';
                row.valueGetter = params => {
                  return params.row.metalOutTime && new Date(params.row.metalOutTime)
                }
                break;
            case "metalOutUpdatedTime":
                row.minWidth = 200;
                row.type = 'dateTime';
                row.valueGetter = params => {
                  return params.row.metalOutUpdatedTime && new Date(params.row.metalOutUpdatedTime)
                }
                break;
            case "logisticAgencyName":
                row.minWidth = 180;
                row.type = 'string';
                row.renderCell = params => {
                  return (
                    <Tooltip title={params.row.logisticAgencyName || "NA"}>
                      <Typography>{params.row.logisticAgencyName || "NA"}</Typography>
                    </Tooltip>
                  )
                }
                break;
            default:
              row.minWidth = 100
              break;
        }
        return row;
    })
  }

  const handleCalcelSTOTransfer = async (stoId: string) => {
    const { data, error } = await execute(() => cancelSTOTransfer({ stoId, centerId: user.centerId || '' }))

    if(!error) {
      notify('Cancelled STO transfer')
      reloadSTOData()
    }
  }

  const reloadSTOData = () => {
    let body = {
      channelId: user.centerId,
      page: paginationModel.page,
      pageSize: paginationModel.pageSize,
      filterModel: filterModel
    }
    execute(() => getStos(body));
  }

  const handleGenerateIRN = async (stoId: string) => {
    const { data, error } = await execute(() => generateIRN({ stoId, type: 'STO' }))

    if(!error) {
      notify('IRN generated successfully')
      reloadSTOData()
    }
  }

  const onFilterChange = useCallback((filterModel: GridFilterModel) => {
    setFilterModel(filterModel)
   }, [])

  useEffect(()=>{
    reloadSTOData()
  }, [paginationModel, filterModel.items[0]?.value])

  return (
    <div style={{padding:"15px 0px 0px 0px"}}>
      <div style={{ borderBottom: '1px solid #d8d8d8', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Stock Transfer Orders</Title>
        
        <div>
          <Button color="primary" variant='contained' disabled={!inventories?.data} onClick={() => setShowSTOModal('true')}>{'Create new STO'}</Button>
          <Button sx={{ marginLeft: "25px"}} color="primary" variant='contained' disabled={!selectedStoIds.length} onClick={() => setEditModalData(selectedStoIds)}>{'BULK STOCK OUT'}</Button>
        </div>
      </div>

      <Table 
        paginationMode={"server"}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        getRowId={(row) => row.stoId} 
        columns={getInventoryColumns()} 
        rows={inventoriesStoRows?.data || []}
        hideFooter={false} 
        rowCount={inventoriesStoRows?.count || 0}
        filterMode='server'
        filterDebounceMs={1000}
        onFilterModelChange={onFilterChange}
        disableRowSelectionOnClick={true}
        pageSizeOptions={[10, 50, 100]}
      />
      
      <Modal open={typeof showLineItemDetail != 'boolean'} title={linedItemModalHeading} onClose={setShowLineItemDetail} maxWidth={'xl'}>
        <LineItemDetailModal lineItemDetails={lineItemDetails} reload={reloadSTOData} onClose={closeAcknowledgeModal} />
      </Modal>

      <Modal open={typeof showActionModal != 'boolean'} title={linedItemModalHeading} onClose={setShowActionModal} maxWidth={'xl'}>
        <ActionModal lineItemDetails={lineItemDetails} stoTransferType={stoTransferType} reload={reloadSTOData} onClose={closeAcknowledgeModal} />
      </Modal>

      <Modal open={typeof showSTOModal != 'boolean'} title={'Create new STO'} onClose={closeSTOModal} maxWidth={'xl'}>
        <CreateStockModal onClose={closeSTOModal} />
      </Modal>

      <Modal open={typeof STOEditModalData != 'boolean'} title={'Update AWB Number'} onClose={closeSTOEditModal}>
        <UpdateSTOItem onClose={closeSTOEditModal} data={STOEditModalData} reload={reloadSTOData} />
      </Modal>

      <Modal open={typeof editModalData != 'boolean'} title={'Edit Plant STO item'} onClose={closeEditModal} maxWidth={'lg'}>
        <EditSTOItem onClose={closeEditModal} data={editModalData} reload={reloadSTOData} setSelectedStoIds={setSelectedStoIds} />
      </Modal>
    </div>
  )
}


function TransactionDetailModal({ data }: TranscationData) {
  return(
    <>
      <List>
        {Object.entries(data).map(([key, value]) => (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ebe6e6'}}>
          <Typography sx={{
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 400,
            padding: '10px',
          }}
        >
          {transcationFields[key] as string}
        </Typography> :
        <Typography sx={{
            color: '#333E48',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 'bold',
            padding: '10px'
          }}
        >
          {(key === 'createdAt' || key === 'updatedAt') ? moment(value).clone().utcOffset('+05:30').format('h:mm a, Do MMM, YYYY') : value || 'NA'}
        </Typography>
      </Box>
      ))}
      </List>
    </>
  )
}


function SerialNumberDetailModal({serialNumbers, activeLineItems, rowStatus, setRowStatus, setShowAcknowledgeSrNoModal}:{serialNumbers?:any, activeLineItems?:any, rowStatus?: any, setRowStatus?:any, setShowAcknowledgeSrNoModal?:any}) {
  let [detail, setDetail] = useState<{id:number,serialNumbers:number,skuId:string}[]>([]);
  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]); 
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  })

  const getInventoryColumns = () => {
    let minWidth = 100

    return INV_SERIALNUMBER_MODAL.map(field => {

        const row: GridColDef = {
            field: field.id,
            headerName: field.label,
            minWidth,
            align: 'left'
        }

        switch (field.id) {
            case "skuId":
                row.minWidth = 200;
                row.renderCell = params => {
                    return params.row.skuId ? params.row.skuId : "NA"
                }
                break;
            case "serialNumbers":
                row.minWidth = 130;
                row.renderCell = params => {
                    return params.row.serialNumbers ? params.row.serialNumbers : "NA"
                }
                break;
            default:
                row.minWidth = 100
                break;
        }
        return row;
    })
  }

  useEffect(()=>{
    let newArr;
    if(activeLineItems) {
      newArr =  activeLineItems.serialNumbers.map((data:any, idx:any)=>{
        return {id: idx, skuId: activeLineItems.skuId, serialNumbers: data}
      })
    }else{
      newArr =  serialNumbers?.serialNumbers.map((data:any, idx:any)=>{
        return {id: idx, skuId: serialNumbers.skuId, serialNumbers: data}
      })
    }
    setDetail(newArr);
  }, [serialNumbers, activeLineItems])

  useEffect(() => {
    let currentItem = rowStatus.find((row: any) => row.id === activeLineItems?.uId)
    setRowSelectionModel(currentItem.selecteRowsId)
  }, [])

  return(
    <div style={{width:"450px"}}>
      <Table 
        checkboxSelection={activeLineItems ? true : false}
        disableRowSelectionOnClick
        slots={{toolbar: GridToolbar}} 
        getRowId={(row) => row.id} 
        columns={getInventoryColumns()} 
        rows={detail} 
        onRowSelectionModelChange={(id) => {
          let newArr : any= [];
          const selectedIDs = new Set(id);

          const selectedRows = detail.filter((row: any) =>
            selectedIDs.has(row.id)
          );
          selectedRows.map((item:any)=> newArr.push(item.serialNumbers))

          setRowStatus((prev:any)=>{
            let newState = [...prev]
            let idx = newState.findIndex((item:any) => item?.id === activeLineItems.uId);
            newState[idx].serialNumbers = newArr;
            newState[idx].selecteRowsId = id;
            if(newArr.length === activeLineItems.serialNumbers.length){
              newState[idx].status = 2;
              setShowAcknowledgeSrNoModal(false)
            }
            return newState;
          })
          setRowSelectionModel(id);
        }}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowSelectionModel={rowSelectionModel}
      />
    </div>
  )
}


function ActionModal({lineItemDetails, stoTransferType, reload, onClose }: {lineItemDetails: any, stoTransferType: any, reload: Function, onClose: Function}) {
  const { inventoriesStoLineItemsRows } = useContext(InventoryContext)
  const [rowStatus, setRowStatus] = useState<RowStatus[]>([]);
  const [showAcknowledgeSrNoModal, setShowAcknowledgeSrNoModal] = useState<boolean | string>(false);
  const [activeLineItems, setActiveLineItem] = useState<any>(null);

  const HandleShowSrNoModal = (params:any) => {
    setActiveLineItem(params);
    setShowAcknowledgeSrNoModal(params);
  }

  function validateWeight(input:any, maxWeight:any) {
    if (input === "") {
      return true;
    }
    // Regular expression to match only numbers or float numbers
    const regex = /^[0-9]+(\.[0-9]+)?$/;
  
    // Check if the input matches the regular expression
    if (!regex.test(input)) {
      return false; // Input doesn't match the pattern
    }
  
    // Convert input to a number
    const number = parseFloat(input);
  
    // Check if the number is less than or equal to 98.523
    return number <= maxWeight;
  }

  const validateQty = (input:any, maxQty:any) => {
    if (input === "") {
      return true;
    }

    const regex = /^[0-9]+$/;

    // Check if the input matches the regular expression
    if (!regex.test(input)) {
      return false; // Input doesn't match the pattern
    }

    // Convert input to a number
    const number = parseInt(input, 10); // Use parseInt to convert string to integer

    // Check if the number is less than 25
    return number < maxQty;
  }

  const HandleQuantityInput = (e:any, currentQty:any, idx:any) => {
    let isValidQty = validateQty(e.target.value, currentQty)
    if(isValidQty){
      let newRowStatusState = [...rowStatus];
      if(e.target.value === ""){
        newRowStatusState[idx].acknowledgedQuantity = "";
      }else {
        newRowStatusState[idx].acknowledgedQuantity = parseFloat(e.target.value);
      }
      setRowStatus(newRowStatusState)
    }
  }

  const HandleWeightInput = (e:any, currentWeight:any, idx:any)=>{
    let isValidWeight = validateWeight(e.target.value, currentWeight)
    if(isValidWeight){
      let newRowStatusState = [...rowStatus];
      if(e.target.value === ""){
        newRowStatusState[idx].acknowledgedWeight = "";
      }else {
        newRowStatusState[idx].acknowledgedWeight = parseFloat(e.target.value);
      }
      setRowStatus(newRowStatusState)
    }
  }

  // const HandleWeightForStatuTwo = (weight:any, currentWeight:any, idx:any) => {
  //   let newRowStatusState = [...rowStatus];
  //   newRowStatusState[idx].acknowledgedWeight = parseFloat(weight);
  //   setRowStatus(newRowStatusState)
  // }

  // const HandleAcknowledgeSerialNumbers = (idx:any, serialNo:any, originalLength:any) => {
  //   // console.log("IDX => ",idx, "SERIAL NO => ", serialNo);
  //   let newrowStatus = [...rowStatus ];
  //   if(newrowStatus[idx].serialNumbers?.includes(serialNo)){
  //     newrowStatus[idx].serialNumbers =  newrowStatus[idx].serialNumbers?.filter((nos:any)=> nos!= serialNo);
  //   }else{
  //     newrowStatus[idx].serialNumbers?.push(serialNo);
  //     // console.log(newrowStatus);
  //     newrowStatus[idx].serialNumbers?.sort((a:any, b:any) => {return a - b})
  //   }

  //   if(newrowStatus[idx].serialNumbers?.length == originalLength){
  //     newrowStatus[idx].status = 2
  //   }
  //   setRowStatus(newrowStatus)
  // }

  useEffect(()=>{
    let newRowStatus = inventoriesStoLineItemsRows?.map((item:any)=>{
      if(item.inventoryType === 1){
        return {id:item.uId, inventoryType: item.inventoryType , status:'', serialNumbers: []}
      }else if(item.inventoryType === 7) {
        return {id:item.uId, inventoryType: item.inventoryType , status:'',  acknowledgedQuantity: ""}
      }else{
        return {id:item.uId, inventoryType: item.inventoryType , status:'',  acknowledgedWeight: ""}
      }
    })
    setRowStatus(newRowStatus)
  }, [inventoriesStoLineItemsRows])

  const overAllRemark = useCallback(() => {
    if(rowStatus.length <= 0) return "N/A"
    let isLostInTransit = rowStatus.filter((item:any)=> item?.status === 4);
    let isFullyAcknowledged = rowStatus.filter((item:any)=> item?.status === 2);
    // if(isLostInTransit.length === rowStatus.length){
    //   return "Lost in transit"; 
    // }

    if(isFullyAcknowledged.length === rowStatus.length){
      return "Acknowledged completely";
    }

    // let isPartiallyLostInTransit = (rowStatus.filter((item:any)=> item.status === 2).length > 0 ||  rowStatus.filter((item:any)=> item.status === 3).length > 0) && rowStatus.filter((item:any)=> item.status === 4).length > 0

    // let isPartiallyLostInTransit2 = rowStatus.filter((item:any)=> item.status === 2).length > 0 || rowStatus.filter((item:any)=> item.status === 3).length > 0 || rowStatus.filter((item:any)=> item.status === 5).length > 0

    let isCancelled = rowStatus.every((item:any)=> item.status === 6)
    if(isCancelled) {
      return "Cancelled"
    }
    
    // if(isPartiallyLostInTransit || isPartiallyLostInTransit2){
    //   return "Partially Lost In Transit"
    // }

    return "Pending..."

  }, [rowStatus]);

  const getActionColumns = () => {
    let minWidth = 100

    return INV_ACTION_MODAL?.map(field => {

        const row: GridColDef = {
            field: field.id,
            headerName: field.label,
            minWidth,
            align: 'left'
        }

        switch (field.id) {
            case "imageURL":
                row.minWidth = 100;
                row.renderCell = params => {
                  let url = params.row.imageURL?.length > 0 ? params.row.imageURL?.sort((a: MyObject, b: MyObject) => a.priority - b.priority)[0].img_url : ''
                return  url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
              }
                break;
            case "name":
                row.minWidth = 550;
                row.renderCell = params => {
                  let name;
                  if(params.row.inventoryType === 1 || params.row.inventoryType === 2 || params.row.inventoryType === 7){
                    name = params.row.name;
                  }else if(params.row.inventoryType === 3){
                    name = "Buffing Dust"
                  }else if(params.row.inventoryType === 4 || params.row.inventoryType === 5 || params.row.inventoryType === 6){
                    name = params.row.globalTransactionNumber
                  }
                  return (
                    <Tooltip title={`${ name ? name : "NA"}`}>
                      <div>
                        {
                          name ? name : "NA"
                        }
                      </div>
                    </Tooltip>
                  )
                }
                break;
            case "inventoryType":
              row.minWidth = 200;
              row.renderCell = params => {
                return getInventoryType(params.row)
              }
              break;
            case "skuId":
                row.minWidth = 180;
                row.renderCell = params => {
                let skuIdToBeShown = (params.row.skuId && (params.row.inventoryType === 1 || params.row.inventoryType === 2))
                  return (
                    <Tooltip title={`${ skuIdToBeShown ? params.row.skuId : "NA" }`}>
                      <div>
                        {
                          skuIdToBeShown ? params.row.skuId : "NA"
                        }
                      </div>
                    </Tooltip>
                  ) 
                }
                break;
            case "unitWeight":
                row.minWidth = 100;
                row.renderCell = params => {
                    let unitWeightToBeShown = params.row.fineWeight && params.row.inventoryType == 1
                    return (
                      <>
                        {
                          unitWeightToBeShown ? params.row.fineWeight : "NA"
                        }
                      </>
                    )
                }
                break;
            case "weight":
                row.minWidth = 100;
                row.renderCell = params => {
                    return params.row.weight ? params.row.weight.toFixed(3) : "NA"
                }
                break;
            case "shape":
                row.minWidth = 100;
                row.renderCell = params => {
                    return params.row.shape ? params.row.shape : "NA"
                }
                break;
            case "purity":
                row.minWidth = 100;
                row.renderCell = params => {
                    return params.row.purity ? params.row.purity : "NA"
                }
                break;
            case "transactionDetails":
                row.minWidth = 100;
                row.renderCell = params => {
                    return <>{params.row.transactionDetails ?
                      <Tooltip title='View transaction Details'>
                        <IconButton ><VisibilityIcon /></IconButton>
                      </Tooltip> : "NA"
                    }</>
                }
                break;
            case "metalType":
                row.minWidth = 150;
                row.renderCell = params => {
                    return params.row.metalType ? params.row.metalType : "NA"
                }
                break;
            case "serialNumbers":
                row.minWidth = 120;
                row.renderCell = params => {
                    return <>{params.row?.serialNumbers && params?.row?.serialNumbers?.length > 0 ?
                      <Tooltip title='View Serial Numbers'>
                        <IconButton><VisibilityIcon /></IconButton>
                      </Tooltip> : "NA"
                    }</>
                }
                break;
            case "actions":
                row.minWidth = 120;
                row.renderCell = params => {
                    return <>{params.row.actions ?
                      <Tooltip title='Line Details'>
                        <IconButton><VisibilityIcon /></IconButton>
                      </Tooltip> : "NA"
                    }</>
                }
                break;
            case "statusLineItem":
                row.minWidth = 200;
                row.renderCell = params => {
                    return <>
                      <LineItemSelect setRowStatus={setRowStatus} params={params.row} rowStatus={rowStatus} stoTransferType={stoTransferType}/>
                    </>
                }
                break;
            case "acknowledgedQuantity":
                row.minWidth = 250;
                row.renderCell = params => {
                    let idx = rowStatus.findIndex((item:any) => item?.id === params?.row?.uId);
                    let status = rowStatus[idx]?.status
                    const isTextFieldEnabled = (idx > -1) && (status === 3 || status === 5);
                    return <>
                      {
                        params.row.inventoryType === 1 ?
                        <Button onClick={()=>HandleShowSrNoModal(params.row)} fullWidth variant="contained" size="small" disabled={((idx > -1) && (status == 3 || status == 5) && params.row.serialNumbers && params.row.serialNumbers.length > 0) ? false : true}>Acknowledge</Button>
                        :
                        <div>
                          { 
                            (params.row.inventoryType !== 7) ?
                            <>
                              {
                                (status === 2) ?
                                <>
                                  {
                                    // HandleWeightForStatuTwo(params.row.weight, params.row.weight, idx)
                                    params.row.weight
                                  }
                                </>
                                :
                                <TextField 
                                  variant="outlined" 
                                  size="small" 
                                  type="number" 
                                  label="Acknowledge Weight"
                                  onChange={(e)=>HandleWeightInput(e, params.row.weight, idx)}
                                  value={rowStatus[idx]?.acknowledgedWeight}
                                  disabled={ isTextFieldEnabled ? false : true}
                                />
                              }
                            </>
                            :
                            (status === 2) ?
                            params.row.quantity
                            :
                            <TextField 
                              variant="outlined" 
                              size="small" 
                              type="number" 
                              label="Acknowledge Quantity"
                              onChange={(e)=>HandleQuantityInput(e, params.row.quantity, idx)}
                              value={rowStatus[idx]?.acknowledgedQuantity}
                              disabled={ isTextFieldEnabled ? false : true}
                            />
                          }
                        </div>
                      }
                    </>
                }
                break;
            case "acknowledgedWeight":
                row.minWidth = 200;
                row.renderCell = params => {
                  let idx = rowStatus.findIndex((item:any) => item?.id === params?.row?.uId);
                  let status = rowStatus[idx]?.status
                  return <>
                    {
                      (params.row.inventoryType !== 1 && (status === 2 || status === 3 || status === 5)) &&
                      <div>
                        {rowStatus[idx].acknowledgedWeight ? rowStatus[idx].acknowledgedWeight : '' }
                      </div>
                    }
                  </>
                }
                break;
            case "acknowledgementRemarks":
                row.minWidth = 200;
                row.renderCell = params => {
                    return <>
                      <TextField 
                        size="small"
                        variant="outlined"
                        label="Remarks"
                        required
                      />
                    </>
                }
                break;
            case "acknowledgedSerialNumbers":
                row.minWidth = 250;
                row.renderCell = params => {
                  let idx = rowStatus.findIndex((item:any) => item?.id === params?.row?.uId);
                  let status = rowStatus[idx]?.status
                  return <>
                    {
                      (params.row.inventoryType == 1 && (status === 2 || status === 3 || status === 5)) &&
                      <Tooltip title={`${rowStatus[idx].serialNumbers?.join(",")}`}>
                        <div>
                          { 
                            rowStatus[idx]?.serialNumbers?.length! > 5 ?
                            `${rowStatus[idx].serialNumbers?.slice(0,5)?.join(",")}...`
                            :
                            rowStatus[idx].serialNumbers?.join(",")
                          }
                        </div>
                      </Tooltip>
                    }
                  </>
                }
                break;
            default:
                row.minWidth = 100
                break;
        }

        return row;
    })
  }

  return (
    <div style={{width:"100%"}}>
      <LineItemDetailModal lineItemDetails={lineItemDetails} getActionColumns={getActionColumns} rowStatus={rowStatus} setRowStatus={setRowStatus} overAllRemark={overAllRemark} reload={reload} onClose={onClose} />
      <Modal open={typeof showAcknowledgeSrNoModal != 'boolean'} title={`${activeLineItems?.name ?? 'Acknowledge Serial Number'}`} onClose={setShowAcknowledgeSrNoModal} >
        <SerialNumberDetailModal activeLineItems={activeLineItems} rowStatus={rowStatus} setRowStatus={setRowStatus} setShowAcknowledgeSrNoModal={setShowAcknowledgeSrNoModal}/>
      </Modal>
    </div>
  )
}


function LineItemDetailModal({lineItemDetails, getActionColumns, rowStatus, setRowStatus, overAllRemark, getSerialNumberModalColumn, reload, onClose}:{lineItemDetails?:any,getActionColumns?:Function,rowStatus?:any, setRowStatus?:any, overAllRemark?:any, getSerialNumberModalColumn?:Function, reload: Function, onClose: Function}) {
  const { execute } = useService()
  const { notify } = useContext(NotificationContext);
  const { inventoriesStoLineItemsRows,inventoriesStoRows } = useContext(InventoryContext)
  const [showTransactionDetailModal, setShowTransactionDetailModal] = useState(false); // Transaction Modal State
  const [lineSerialNumbers, setLineSerialNumbers] = useState(false);
  // const [paginationModel, setPaginationModel] = useState({page: 0,pageSize: 10}) // Pagination State
  const [stoRemark, setStoRemark] = useState(''); // Remark State
  
  const closeTransactionDetailsModal = () => {
    setShowTransactionDetailModal(false)
  }

  const closeSerialNumbersModal = () => {
    setLineSerialNumbers(false)
  }
  
  const getLineItemColumns = () => {
    let minWidth = 100

    return INV_LINEITEM_MODAL.map(field => {

      const row: GridColDef = {
          field: field.id,
          headerName: field.label,
          minWidth,
          align: 'left'
      }

      switch (field.id) {
        case "imageURL":
            row.minWidth = 100;
            row.renderCell = params => {
                let url = params.row.imageURL?.length > 0 ? params.row.imageURL?.sort((a: MyObject, b: MyObject) => a.priority - b.priority)[0].img_url : ''
                return  url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
            }
            break;
        case "name":
            row.minWidth = 550;
            row.renderCell = params => {
              let productName;
                if(params.row.inventoryType === 1 || params.row.inventoryType === 2 || params.row.inventoryType === 7){
                  productName = params.row.name;
                }else if(params.row.inventoryType === 3){
                  productName = "Buffing Dust"
                }else if(params.row.inventoryType === 4 || params.row.inventoryType === 5 || params.row.inventoryType === 6){
                  productName = params.row.globalTransactionNumber
                }
                return (
                  <Tooltip title={productName}>
                    <Typography>{productName}</Typography>
                  </Tooltip>
                ) 
            }
            break;
        case "inventoryType":
            row.minWidth = 200;
            row.renderCell = params => {
              return getInventoryType(params.row)
            }
            break;
        case "skuId":
            row.minWidth = 200;
            row.renderCell = params => {
              let skuId = params.row.skuId ? params.row.skuId : 'NA'
                return (
                  <Tooltip title={skuId}>
                    <Typography>{skuId}</Typography>
                  </Tooltip>
                )  
            }
            break;
        case "fineWeight":
            row.minWidth = 100;
            row.renderCell = params => {
                return params.row.fineWeight ? params.row.fineWeight : "NA"
            }
            break;
        case "weight":
            row.minWidth = 100;
            row.renderCell = params => {
                return params.row.weight ? params.row.weight.toFixed(3) : "NA"
            }
            break;
        case "purity":
            row.minWidth = 100;
            row.renderCell = params => {
                return params.row.purity ? params.row.purity : "NA"
            }
            break;
        case "transactionDetails":
            row.minWidth = 180;
            row.renderCell = params => {
              let isValidInventory = params.row.inventoryType === 4 || params.row.inventoryType === 5 || params.row.inventoryType === 6
              let iconTobeShown = params.row.transactionDetails && isValidInventory
                return <>{ iconTobeShown ?
                  <Tooltip title='View transaction Details'>
                    <IconButton onClick={()=>setShowTransactionDetailModal(params.row.transactionDetails)}><VisibilityIcon /></IconButton>
                  </Tooltip> : "NA"
                }</>
            }
            break;
        case "metalType":
            row.minWidth = 150;
            row.renderCell = params => {
              return params.row.metalType ? params.row.metalType : "NA"
            }
            break;
        case "serialNumbers":
            row.minWidth = 150;
            row.renderCell = params => {
              let shouldIconBeShown = (params.row.inventoryType === 1)  && params.row.serialNumbers 
              return <>
                { shouldIconBeShown ?
                  <Tooltip title='View Serial Numbers'>
                    <IconButton style={{ marginLeft: '-10px' }} onClick={()=>setLineSerialNumbers({...params.row, unitWeight: params.row.weight, serialNumbers: JSON.stringify(params.row.serialNumbers)})}><VisibilityIcon /></IconButton>
                  </Tooltip>
                  : 
                  "NA"
                }
              </>
            }
            break;
        default:
            row.minWidth = 100
            break;
      }
      return row;
    })
  }

  const markLostIntransit = () => {
    setRowStatus((prev:any)=>{
      let markedLost = prev.map((item:any)=> {
        if('serialNumbers' in item){
          item.serialNumbers = []
        }
        if('acknowledgedWeight' in item) {
          item.acknowledgedWeight = ''
        }
        if('acknowledgedQuantity' in item) {
          item.acknowledgedQuantity = ''
        }
        item.status = 4
        return item
      });
      return markedLost;
    })
  }

  function buildMetalPayload(results: ResultItem[], dataTransfer: MTSDataTransferType) {
    if (!results?.length) return null;

    const goldItems: ResultItem[] = [];
    const silverItems: ResultItem[] = [];

    // Separate by metal type
    for (const item of results) {
      if (item.metalType === 'gold') {
        goldItems.push(item);
      } else if (item.metalType === 'silver') {
        silverItems.push(item);
      }
    }

    // Enforce single metal rule
    // if (goldItems.length && silverItems.length) {
    //   return notify('Multiple metal types found. Only one metal allowed per STO.', 'error');
    // }

    const selectedItems = goldItems.length ? goldItems : silverItems;
    if (!selectedItems.length) return null;

    // Transform to PROD format
    const transformedItems = selectedItems.map((item) => {
      const fineWeight = Number(
        (
          item.buffingDustFine
            ? item.fineWeight - item.buffingDustFine
            : item.fineWeight
        ).toFixed(3)
      );

      return {
        LotNo: item.id,
        NetWeight: Number(item.wamt.toFixed(3)),
        Purity: Number(item.fineness.toFixed(3)),
        FineWeight: fineWeight
      };
    });

    // Calculate totals
    const totals = transformedItems.reduce(
      (acc, item) => {
        acc.TotalNetWeight += item.NetWeight;
        acc.TotalFineWeight += item.FineWeight;
        return acc;
      },
      {
        TotalNetWeight: 0,
        TotalFineWeight: 0
      }
    );

    // Normalize totals
    totals.TotalNetWeight = Number(totals.TotalNetWeight.toFixed(3));
    totals.TotalFineWeight = Number(totals.TotalFineWeight.toFixed(3));

    const baseData = {
      InvoiceNo: dataTransfer.invoiceDetails.document_number,
      InvoiceDate: dataTransfer.invoiceDetails.created_at,
      PVCCode: dataTransfer.mts_location_code,
      Name: dataTransfer.shipperId,
      Remarks: dataTransfer.remarks,
      LineItemXML: ''
    };

    // 🔹 Final PROD payload
    return {
      ...baseData,
      ...totals,
      MetalType: goldItems.length ? 'MTG' : 'MTS',
      pvcMetalInboundItemModel: transformedItems
    };
  }

  /* ========================================================= */

  const handleSubmitAcknowledge = async () => {

    let payload: any = {
      stoId: lineItemDetails,
      acknowledgedLineItems: rowStatus,
      stoRemark: stoRemark
    };

    // Validate row status
    let isRowStatusUpdate =
      rowStatus.length > 0 &&
      rowStatus.every((row: any) => row.status);

    if (!isRowStatusUpdate) {
      return notify('Please update line item status!', 'error');
    }

    if (!stoRemark.length) {
      return notify('Please update remarks!', 'error');
    }

    // Validate acknowledged qty/weight
    let isLineItemDetailsUpdated =
      rowStatus.length > 0 &&
      rowStatus.every((row: any) => {
        if ([3, 5].includes(Number(row?.status))) {
          return !!(row?.acknowledgedWeight || row?.acknowledgedQuantity);
        }
        return true;
      });

    if (!isLineItemDetailsUpdated) {
      return notify(
        'Please update Acknowledged quantity/weight of the line item!',
        'error'
      );
    }

    // Submit
    const { data, error } = await execute(() => acknowledgeStockTransferOrder(payload));
    if (!error) {
      onClose();
      notify('STO Acknowledged successfully');
      reload();
    }
  }

  useEffect(()=>{
    let body = {
      stoId: lineItemDetails
    }
    execute(() => getStosLineItem(body));
  }, [])

return (
  <div style={{width:"80vw"}}>
      <Table
        getRowId={(row) => row.uId} 
        columns={getActionColumns ? getActionColumns(): getSerialNumberModalColumn? getSerialNumberModalColumn() : getLineItemColumns()} 
        rows={(inventoriesStoLineItemsRows && inventoriesStoLineItemsRows.length > 0) ? inventoriesStoLineItemsRows:[]}
        hideFooter={false} 
      />

      {
        getActionColumns &&
        <div>
          <Typography sx={{color:'gray', fontSize:'20px', marginTop:"10px"}}>
            STO Status : 
            <Typography component={'span'} sx={{color:'black', fontSize:'18px', marginLeft:"20px"}}>
              {overAllRemark && overAllRemark()}
            </Typography>
          </Typography>
          <TextField
            sx={{margin:"20px 0px 0px 0px"}}
            fullWidth
            id="outlined-multiline-flexible"
            label="Remarks"
            multiline
            maxRows={4}
            required
            value={stoRemark}
            onChange={(e)=>setStoRemark(e.target.value)}
          />
          <div style={{marginTop:"20px", display:'flex', gap:"20px"}}>
            {/* <Button variant="contained" onClick={ markLostIntransit }> Mark as lost in transit </Button> */}
            <Button variant="contained" onClick={ handleSubmitAcknowledge }> Submit acknowledgement </Button>
          </div>
        </div>
      }
      <Modal open={typeof showTransactionDetailModal != 'boolean'} title={"Transaction Details"} onClose={closeTransactionDetailsModal}>
        {/* <TransactionDetailModal data={showTransactionDetailModal}/> */}
        <ShowTranscationDetails data={showTransactionDetailModal}/>
      </Modal>
 
      <Modal open={typeof lineSerialNumbers != 'boolean'} title={"Serial Numbers"} onClose={closeSerialNumbersModal} maxWidth={'xl'}>
        <ShowSerialNumbers data={lineSerialNumbers}/>
      </Modal>
  </div>
)
}


function LineItemSelect({params, setRowStatus, rowStatus, stoTransferType}:{params:any, setRowStatus:Function, rowStatus?:any, stoTransferType: any}) {

  const [lineItemStatus, setLineItemStatus] = useState('');
  
  const handleChange = (e: SelectChangeEvent)=>{
    setLineItemStatus(e.target.value)
    setRowStatus((prev:any)=>{
      let idx = prev.findIndex((item:any) => item.id === params?.uId);
      let newArr = [...prev];
      newArr[idx] = {...newArr[idx], status:e.target.value}
      if(idx > -1) {
        if(params.inventoryType === 1 ){
          if(e.target.value == '2') {
            newArr[idx] = {...newArr[idx], status:e.target.value, serialNumbers: params.serialNumbers}
          }else {
            newArr[idx] = {...newArr[idx], status:e.target.value, serialNumbers: []}
          }
        } else if(params.inventoryType === 2 || params.inventoryType === 3 || params.inventoryType === 4 || params.inventoryType === 5 || params.inventoryType === 6){
          if(e.target.value == '2') {
            newArr[idx] = {...newArr[idx], status:e.target.value, acknowledgedWeight: params.weight}
          }else{
            newArr[idx] = {...newArr[idx], status:e.target.value, acknowledgedWeight: ''}
          }
        }else{
          if(e.target.value == '2') {
            newArr[idx] = {...newArr[idx], status:e.target.value, acknowledgedQuantity: params.quantity}
          }else{
            newArr[idx] = {...newArr[idx], status:e.target.value, acknowledgedQuantity: ''}
          }
        }
        return newArr;
      } else {
        if(params.inventoryType == 1 && e.target.value == '2'){
          return [...prev, {id: params?.id, status:e.target.value, serialNumbers: JSON.parse(params.serialNumbers)}]
        }
        return [...prev, {id: params?.id, status:e.target.value, serialNumbers:[]}]
      }
    })
  }

  useEffect(()=>{
    let idx = rowStatus.findIndex((item:any) => item?.id === params?.uId);
    if(idx > -1){
      setLineItemStatus(rowStatus[idx].status);
    }
  }, [rowStatus])


  let stoLineItemStatusArray = (stoTransferType === 'inbound')  ? inboundsStatus : outboundStatus

  return(
    <FormControl fullWidth size="small">
      <InputLabel id="demo-simple-select-label">Line Item Status</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={lineItemStatus}
        label="Line Item Status"
        onChange={handleChange}
        required
      >
        {
          stoLineItemStatusArray.map((item: any) => {
            return <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
          })
        }
      </Select>
    </FormControl>
  )
}


function UpdateSTOItem({ onClose, data, reload }: { onClose: any, data: any, reload: any }) {
  let { stoId, awbNumber } = data

  const { notify } = useContext(NotificationContext);
  const { execute } = useService()
  const [AWbNumber, setAWbNumber] = useState<string>(awbNumber ?? '')

  const handleUpdateSTO = async () => {
    if(!AWbNumber || !stoId) return 

    let params = {
      awbNumber: AWbNumber,
      stoId: stoId
    }

    const { data, error } = await execute(() => updateAWBNumber(params as unknown as IStoUpdate))

    if(!error) {
      onClose()
      notify('AWB Number updated')
      reload()
    }
  }

  return (
    <>
      <Row>
        <TextField
          label="AWB Number"
          value={AWbNumber}
          variant="outlined"
          onChange={(e) => setAWbNumber(e.target.value)}
          sx={{ width: 350, marginRight: 2 }}
        />
        <Button color="primary" variant="contained" onClick={handleUpdateSTO} disabled={!AWbNumber}>Update</Button>
      </Row>

      {/* <Stack width="100%" marginTop="25px" direction="row" justifyContent="flex-end" gap="10px" align-items="center">
        <Button color="primary" variant="contained" onClick={handleCalcelSTOTransfer} disabled={status !== '0'}>Cancel STO</Button>
      </Stack> */}
    </>
  )
}

type TStoId = string | string[];
interface IProps {
  onClose: () => void;
  reload: () => void;
  data: boolean | TStoData | TStoData[];
  setSelectedStoIds: React.Dispatch<React.SetStateAction<TStoData[]>>;
}

function EditSTOItem({ onClose, data, reload, setSelectedStoIds }: IProps) {
  
  const { notify } = useContext(NotificationContext);
  const { execute } = useService()
  const [formData, setFormData] = useState({ selectedDateTime: "" });
  const [confirmOpen, setConfirmOpen] = useState(false);

  let latestItem: TStoData | null = null;
  if (Array.isArray(data) && data.length > 0) {
    latestItem = data.reduce<TStoData>((latest, current) => {
      return new Date(current.createdAt) > new Date(latest.createdAt)
        ? current
        : latest;
    }, data[0]);
  } else if (data && typeof data === 'object' && 'createdAt' in data) {
    latestItem = data;
  }

  const changeHandler = (value: string, field: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }

  const handleCancel = () => {
    setFormData({ selectedDateTime: "" });
  }

  const handleConfirm = () => {
    setConfirmOpen(true);
  }

  const handleConfirmCancel = () => {
    setConfirmOpen(false);
  }

  const stoIds: TStoId = []
  if(Array.isArray(data)) {
    for (const item of data) {
      if (item.stoId) {
        stoIds.push(item.stoId);
      }
    }
  }  else {
    if (data && typeof data === 'object' && 'stoId' in data) {
      stoIds.push(data.stoId);
    }
  }

  const handleStockOutDetail = async () => {
    let params = {
      stoIds: stoIds,
      metalOutTime: formData.selectedDateTime
    }

    const { data, error } = await execute(() => stockOutDetail(params))

    if(!error) {
      reload?.()
      onClose?.()
      setSelectedStoIds([])
      setConfirmOpen(false)
      notify('PLANT STO updated')
    }
  }

  return (
    <div style={{ width: '400px', padding: '20px' }}>
      <DateTimePicker
        value={formData.selectedDateTime ? moment(formData.selectedDateTime) : null}
        onChange={(m) => changeHandler(m ? m.toString() : "", "selectedDateTime")}
        label="Date From"
        invoiceDate={latestItem ? latestItem.createdAt : undefined}
      />
      <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 1, pt: 1, marginTop: '20px' }}>
        <Button variant="outlined" color="error" size="small" onClick={handleCancel} sx={{ minWidth: 84 }}>Cancel</Button>
        <Button variant="contained" color="primary" size="small" onClick={handleConfirm} disabled={!formData.selectedDateTime} sx={{ minWidth: 90 }}>Confirm</Button>
      </Stack>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmOpen}
        onClose={handleConfirmCancel}
        maxWidth="xs"
        fullWidth
        aria-labelledby="confirm-dialog-title"
        PaperProps={{
          sx: {
            minWidth: 450,  
            minHeight: 200,
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle id="confirm-dialog-title">Please confirm</DialogTitle>
        <Divider />
        <DialogContent
          sx={{
            p: 3,
          }}
        >
          <Typography variant="body2" style={{ fontSize: "16px" }}>
            Are you confirm to update this STO row with date:{" "}
            <strong>
              {formData.selectedDateTime
                ? moment(formData.selectedDateTime).format("YYYY-MM-DD HH:mm")
                : "-"}
            </strong>
            ?
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 2, pb: 2 }}>
          <Stack direction="row" spacing={1} sx={{ width: "100%" }} justifyContent="flex-end">
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={handleConfirmCancel}
              sx={{ minWidth: 84 }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleStockOutDetail}
              sx={{ minWidth: 90 }}
            >
              Confirm
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </div>
  );
}